import {
  createCustomField as publicCreateCustomField,
  getCustomField as publicGetCustomField,
  listCustomFields as publicListCustomFields,
  updateCustomField as publicUpdateCustomField,
  deleteCustomField as publicDeleteCustomField,
  hideCustomField as publicHideCustomField,
  updateCustomFieldsOrder as publicUpdateCustomFieldsOrder,
} from './members-v1-custom-field-custom-fields.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const createCustomField: MaybeContext<
  BuildRESTFunction<typeof publicCreateCustomField> &
    typeof publicCreateCustomField
> = /*#__PURE__*/ createRESTModule(publicCreateCustomField);
export const getCustomField: MaybeContext<
  BuildRESTFunction<typeof publicGetCustomField> & typeof publicGetCustomField
> = /*#__PURE__*/ createRESTModule(publicGetCustomField);
export const listCustomFields: MaybeContext<
  BuildRESTFunction<typeof publicListCustomFields> &
    typeof publicListCustomFields
> = /*#__PURE__*/ createRESTModule(publicListCustomFields);
export const updateCustomField: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCustomField> &
    typeof publicUpdateCustomField
> = /*#__PURE__*/ createRESTModule(publicUpdateCustomField);
export const deleteCustomField: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCustomField> &
    typeof publicDeleteCustomField
> = /*#__PURE__*/ createRESTModule(publicDeleteCustomField);
export const hideCustomField: MaybeContext<
  BuildRESTFunction<typeof publicHideCustomField> & typeof publicHideCustomField
> = /*#__PURE__*/ createRESTModule(publicHideCustomField);
export const updateCustomFieldsOrder: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCustomFieldsOrder> &
    typeof publicUpdateCustomFieldsOrder
> = /*#__PURE__*/ createRESTModule(publicUpdateCustomFieldsOrder);

export {
  Privacy,
  Type,
  SocialTypeType,
  Origin,
  AppliesTo,
  Section,
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  WebhookIdentityType,
} from './members-v1-custom-field-custom-fields.universal.js';
export {
  CustomField,
  CreateCustomFieldRequest,
  CreateCustomFieldResponse,
  IncorrectFieldTypeData,
  IncorrectPrivacyData,
  InvalidSocialTypeData,
  GetCustomFieldRequest,
  GetCustomFieldResponse,
  ListCustomFieldsRequest,
  Paging,
  ListCustomFieldsResponse,
  PagingMetadata,
  UpdateCustomFieldRequest,
  UpdateCustomFieldResponse,
  DefaultPrivacyChanged,
  ReservedFieldNameNonEditable,
  DeleteCustomFieldRequest,
  DeleteCustomFieldResponse,
  HideCustomFieldRequest,
  HideCustomFieldResponse,
  UpdateCustomFieldsOrderRequest,
  UpdateCustomFieldsOrderResponse,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  ListCustomFieldsOptions,
  UpdateCustomField,
  UpdateCustomFieldsOrderOptions,
} from './members-v1-custom-field-custom-fields.universal.js';
export {
  PrivacyWithLiterals,
  TypeWithLiterals,
  SocialTypeTypeWithLiterals,
  OriginWithLiterals,
  AppliesToWithLiterals,
  SectionWithLiterals,
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateCustomFieldApplicationErrors,
  UpdateCustomFieldApplicationErrors,
} from './members-v1-custom-field-custom-fields.universal.js';
